import styled from '@emotion/styled'

export const Body = styled.div<{ height: string | number | undefined }>(
  ({ height }) => `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 300ms cubic-bezier(0.75, 0.02, 0.5, 1);

  &.enter {
    max-height: 0px;
  }

  &.enter-active {
    max-height: ${height}px;
  }

  &.enter-done {
    max-height: ${height}px;
  }

  &.exit {
    max-height: ${height}px;
  }

  &.exit-active {
    max-height: 0px;
  }
  &.exit-done {
    max-height: 0px;
  }
`
)

export const Header = styled.div<{ margin?: string }>(
  ({ margin }) => `
  position: relative;
  z-index: 1;
  cursor: pointer;

  ${margin && `margin: ${margin}`};
`
)
